import { StyleSheet, css } from 'aphrodite'
import type React from 'react'
import { useEffect, useRef, useState } from 'react'
import Modal from '../Modal'
import OnboardingStepPersonalInfo from './OnboardingStepPersonalInfo'
import OnboardingStepAddContacts from './contractor/OnboardingStepAddContacts'
import OnboardingStepComplete from './contractor/OnboardingStepComplete'
import OnboardingStepWelcome from './contractor/OnboardingStepWelcome'

interface ContractorOnboardingModalProps {
  open: boolean
  onClose: () => void
}

const steps = [
  'Welcome',
  'Personal Information',
  'Add Contacts',
  'Review and Complete',
]

const ContractorOnboardingModal: React.FC<ContractorOnboardingModalProps> = ({
  open,
  onClose,
}) => {
  const [step, setStep] = useState(0)
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!open) setStep(0)
  }, [open])

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollTop = 0
    }
  }, [step])

  if (!open) return null

  return (
    <Modal onClose={onClose} maxWidth={600}>
      <div ref={containerRef} className={css(styles.container)}>
        {step === 0 && <OnboardingStepWelcome onNext={() => setStep(1)} />}
        {step === 1 && (
          <OnboardingStepPersonalInfo
            onNext={() => setStep(2)}
            onBack={() => setStep(0)}
          />
        )}
        {step === 2 && (
          <OnboardingStepAddContacts
            onNext={() => setStep(3)}
            onBack={() => setStep(1)}
          />
        )}
        {step === 3 && <OnboardingStepComplete onClose={onClose} />}
      </div>
    </Modal>
  )
}

const styles = StyleSheet.create({
  container: {
    padding: 'clamp(24px, 5vw, 48px)',
    width: '100%',
    maxWidth: 600,
    height: 'min(80vh, 800px)',
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    background: '#F9FAFB',
    borderRadius: 12,
  },
})

export default ContractorOnboardingModal
